import React from 'react'
import { Modal } from 'antd'

const Protocol = (props) => {
  const { modalVisible, onCancel } = props
  return (
    <Modal
      destroyOnClose
      title='宁波概而论网络科技有限公司用户使用协议'
      visible={modalVisible}
      onCancel={() => onCancel()}
      width={800}
      footer={null}
    >
      <iframe title='protocol' style={{ width: '100%', height: '620px' }} src='https://oss.gerlun.com/files/agreement/xy.html' frameborder='0'></iframe>
    </Modal>
  )
}

export default Protocol
